// Label and colours for a job priority, shared by the dispatch timeline and map.
export const priorityMapping = (priority) => {
  switch ((priority || "").toLowerCase()) {
    case "urgent":
      return { emoji: "🔥", label: "Urgent", background: "#FFEBEE", text: "#C62828" };
    case "waiting_on_parts":
      return { emoji: "🛠️", label: "Waiting on Parts", background: "#EFEBE9", text: "#4E342E" };
    case "high":
      return { emoji: "⚠️", label: "High", background: "#FFF3E0", text: "#E65100" };
    case "medium":
      return { emoji: "👀", label: "Medium", background: "#FFFDE7", text: "#F57F17" };
    case "normal":
    default:
      return { emoji: "💤", label: "Low", background: "#E1F5FE", text: "#01579B" };
  }
};

// Values to send when filtering by priority. Jobs default to "low" in the
// database but the web picker saves "normal", so Low has to match both.
export const priorityQueryValues = (values) => {
  if (!values || values.length === 0) return undefined;
  const expanded = values.flatMap((value) => (value === "normal" || value === "low" ? ["normal", "low"] : [value]));
  return Array.from(new Set(expanded));
};
